import {
    Env
} from './env.js'; //ブラウザなど環境チェック
import {
    LazyLoad
} from './lazyload.js';
import {
    ScrChecker
} from './scroll-checker-simple.js';
import {
    ToTopBtnChecker
} from './scroll-checker-btntotop.js';
import {
    Opening
} from './opening.js'; //オープニング関連
import {
    BgLink
} from './bglink.js';
import {
    PageAncher
} from './page-ancher.js'; //ページ内アンカーリンク（スムーズスクロール）
import smoothscroll from 'smoothscroll-polyfill';
// https://www.npmjs.com/package/smoothscroll-polyfill
// http://iamdustan.com/smoothscroll/

// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
    constructor() {
        this.timerResized = false; //resize時
        this.timerScrolled = false; //scroll時
        this._click = '';
        this.env = {};
        //this.youtubeLazy = {};
        this.loadedFlg = false;
        this.scrChecker = {};
        //this.pageAncher = {};
        //this.accordions = {};
        this.sliders = {};
        this.openingManager = {};
        this.tabs = {};
        //this.sizeint= {};
        this.resize = {};
        //this.dmenu = {};
        this.scrToTopBtnChecker = {};
    }

    init() {

        // DOMContentLoaded時
        // ------------------------------
        window.addEventListener('DOMContentLoaded', () => {

            this.body = document.getElementsByTagName('body')[0];
            this.html = document.getElementsByTagName('html')[0];

            // ブラウザOS環境
            this.env = new Env();
            this.env.detectEnv();


            // スクロールチェッカー
            this.scrChecker = new ScrChecker();

            // スクロールチェッカー(ToTopBtn)
            this.scrToTopBtnChecker = new ToTopBtnChecker();
            //this.scrToTopBtnChecker.init();

            // スクロール時
            window.addEventListener('scroll', () => {
                this.scrChecker.onUpdate();
                this.scrToTopBtnChecker.onUpdate(); //ToTopBtn
            });

            // ウインドウリサイズ時
            window.addEventListener('resize', () => {
                this.scrChecker.onUpdate();
                this.scrToTopBtnChecker.onUpdate(); //ToTopBtn
                if (this.timerResized !== false) {
                    clearTimeout(this.timerResized);
                }
                this.timerResized = setTimeout(() => {
                    this.scrChecker.onUpdate();
                    this.scrChecker.onResizeMov();
                    this.openingManager.dmenu.envCheck();
                    this.openingManager.onResize();
                }, 700);
            });

            // Openingチェッカー
            this.openingManager = new Opening();
            this.openingManager.init();
            this.openingManager.onResize();

        });

        // load時
        // ------------------------------
        window.addEventListener("load", () => {
            this.loadedFlg = true;
            window.setTimeout(() => {
                this.body.classList.add('loaded');
            }, 400);


            window.setTimeout(() => {
                this.openingManager.showMainContent();
                this.scrChecker.init();
                this.scrChecker.onUpdate();

                // lazy load : PC Safari 対策
                let lazyload = new LazyLoad();
                lazyload.init();

                // エリア全体リンク
                this.bglink = new BgLink();
                this.bglink.init();

                //page ancher
                smoothscroll.polyfill();
                this.pageAncher = new PageAncher();
                this.pageAncher.init();

            }, 300);


            // Opening開始
            if (this.openingManager.openingFlg) {
                this.openingManager.startOpening();
            } else {
                this.openingManager.skipOpening();
            }

        });
    }
}